// extracted by mini-css-extract-plugin
export var stepActive = "_47-3";
export var stepCompleted = "_47-4";
export var stepConnectorLine = "_47-b";
export var stepIndicatorCircle = "_47-6";
export var stepIndicatorCircleCompleted = "_47-7";
export var stepIndicatorCircleDefault = "_47-8";
export var stepIndicatorTextCompleted = "_47-9";
export var stepIndicatorTextDefault = "_47-a";
export var stepPending = "_47-5";
export var wizardContainer = "_47-1";
export var wizardContent = "_47-2";
export var wizardModal = "_47-0";